import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

class Hero {
  $block: JQuery<HTMLElement>;
  $pagination: JQuery<HTMLElement>;
  swiper: Swiper | null;

  constructor() {
    this.$block = $('.hero');
    this.$pagination = this.$block.find('.swiper-pagination');
    this.swiper = null;

    this.init();
  }

  init() {
    if (!this.$block.length) return;

    this.swiper = new Swiper('.hero .swiper', {
      modules: [Pagination, Autoplay],
      loop: true,
      pagination: {
        el: this.$pagination[0],
        clickable: true,
      },
      autoplay: {
        delay: 5000,
      },
      speed: 700,
    });
  }
}

export default Hero;
